import { useI18n } from "../lib/i18n";
export function useFormatDuration() {
    var _useI18n = useI18n(), formatNumber = _useI18n.formatNumber, formatList = _useI18n.formatList;
    var formatDuration = function(duration) {
        var unitDisplay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'long';
        var list = [];
        if (duration === null || duration === void 0 ? void 0 : duration.hours) {
            list.push(formatNumber(duration.hours, {
                style: 'unit',
                unit: 'hour',
                unitDisplay: unitDisplay
            }));
        }
        if (duration === null || duration === void 0 ? void 0 : duration.minutes) {
            list.push(formatNumber(duration.minutes, {
                style: 'unit',
                unit: 'minute',
                unitDisplay: unitDisplay
            }));
        }
        if (duration === null || duration === void 0 ? void 0 : duration.seconds) {
            list.push(formatNumber(duration.seconds, {
                style: 'unit',
                unit: 'second',
                unitDisplay: unitDisplay
            }));
        }
        return formatList(list);
    };
    return {
        formatDuration: formatDuration
    };
}
